import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MemoRow from './row';
import { updateGrid as updateG, updateDestination, updateSuppBranch } from '../../redux/darazBulkBookingSlice';

const Grid = () => {
    const dispatch = useDispatch();
    const { services } = useSelector(state => state.appData);
    console.log('grid rendered');
    const state = useSelector(state => { return { appData: state.appData, darazBulkBookingData: state.darazBulkBookingData } });
    const { destinations, userInfo } = state.appData;
    const {
        data,
        grid } = state.darazBulkBookingData;

    const updateGrid = (index, key, val) => {
        dispatch(updateG({ index, key, val }));
    };

    const updateDest = (index, val) => {
        dispatch(updateDestination({ index, val, dests: destinations }));
    }

    const updateSuppBr = (index, val) => {
        dispatch(updateSuppBranch({ index, val, dests: destinations }));
    }

    return <div className="row mt-2">
        <div className="table-responsive">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Consignment No</th>
                        <th>Booking Date</th>
                        <th>ConsigneeName</th>
                        <th>ConsigneeAddress</th>
                        <th>ConsigneeMobileNumber</th>
                        <th>ConsigneeEmail</th>
                        <th>DestinationCity</th>
                        <th>Pieces</th>
                        <th>Weight</th>
                        <th>CODAmount</th>
                        <th>CustomerReferenceNumber</th>
                        <th>SpecialHandling</th>
                        <th>ServiceType</th>
                        <th>ProductDetails</th>
                        <th>Remarks</th>
                        <th>DRTV</th>
                        <th>SupplierName</th>
                        <th>SupplierAddress</th>
                        <th>SupplierBranch</th>
                        <th>SupplierPhone</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        grid.map((x, index) => <MemoRow key={index} x={{ ...x, isCod: data.isCod }} formData={data} index={index} services={services} destinations={destinations} user={userInfo} updateGrid={updateGrid} updateDest={updateDest} updateSuppBr={updateSuppBr} />)
                    }
                </tbody>
            </table>
        </div>
    </div>
}

export default Grid;
